import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b71f270c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b71f270c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b71f270c')) {
      api.createRecord('b71f270c', component.options)
    } else {
      api.reload('b71f270c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b71f270c", function () {
      api.rerender('b71f270c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/userSelect/index.vue"
export default component.exports